@let orderStatus = order().status.value;

@if (isOrderFinished()) {
  @if (!isInactive()) {
    <app-order-modal-finished-section-main-widget
      [order]="order()"
    ></app-order-modal-finished-section-main-widget>
  }

  @if (
    [OrderStatus.WAITING_FOR_PAYMENT, OrderStatus.PARTIALLY_PAID].includes(
      orderStatus
    )
  ) {
    @let payment = order().payment;
    <onyx-widget-box heading="labels.invoice">
      {{ payment.invoice?.number }}
    </onyx-widget-box>

    <app-order-modal-outstanding-payment
      [payment]="payment"
    ></app-order-modal-outstanding-payment>
  }

  @if (orderStatus === OrderStatus.PAID) {
    @if (finishedOrderData(); as finishedData) {
      <onyx-widget-box [heading]="`${I18N}.finishedOrder`">
        <div class="finished-order">
          {{ finishedData.date | onyxDate: 'date' }}

          <span>·</span>

          {{ finishedData.time | onyxTime }}
        </div>
      </onyx-widget-box>
    }

    <onyx-widget-box heading="labels.paymentTerm">
      {{ this.order().payment.invoice!.paymentTerm | onyxDate: 'date' }}
    </onyx-widget-box>
  }
}
